/*
 * @Author: yidan.chen
 * @Date: 2025-05-15 14:30:06
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-05-15 15:59:01
 */

import { commonServerInstance, downloadInstance } from '@/utilities/instances'
import { downloadFile } from '@/service/common'

export interface ISLAExtensionHistoryRecord {
  id: string
  tno: string
  merchantRefNo: string
  mawb: string
  workBatch: string
  parentMerchant: string
  merchant: string
  inductTime: string
  inductWhs: string
  destWhs: string
  lastEvent: string
  lastEventTime: string
  reason: string
  hoursExtended: number
  uploadTime: string
  dwProcessedTime: string | null
}

export interface ISLAExtensionHistoryResponse {
  total?: number
  data?: Array<ISLAExtensionHistoryRecord>
  unique_dest_warehouse?: number
  unique_tnos?: number
  pending_dw?: number
}

export interface ISLAExtensionHistoryParams {
  order_ids?: string
  parent_merchant?: string
  merchant?: string
  tno?: string
  mawb?: string
  work_batch?: string
  induct_time?: string
  page?: number | string
  per_page?: number | string
}

/**
 * Fetch SLA Extension History records
 * @param params - Filter parameters for the search
 */
export const fetchSLAExtensionHistory = async (
  params: ISLAExtensionHistoryParams
): Promise<ISLAExtensionHistoryResponse> => {
  const response = await commonServerInstance.post(
    '/api/v1/sla-extensions/history/search',

    params
  )
  return response?.data?.data
}

/**
 * Download selected SLA Extension History records
 * @param params - Filter parameters including selected IDs
 */
export const downloadSLAExtensionHistory = async (
  params: ISLAExtensionHistoryParams
): Promise<any> => {
  const response = await downloadInstance.post(
    '/api/v1/sla-extensions/history/export',
    params,
    {
      responseType: 'blob'
    }
  )
  return downloadFile(response, 'SLA_Extension_History.xlsx')
}

export const fetchParentMerchant = async (): Promise<
  Array<{ id: string; name: string }>
> => {
  const response = await commonServerInstance.get(
    '/api/v1/sla-extensions/parent-merchants'
  )
  return response?.data?.data
}

export const fetchMerchant = async (): Promise<
  Array<{ id: string; name: string }>
> => {
  const response = await commonServerInstance.get(
    '/api/v1/sla-extensions/merchants'
  )
  return response?.data?.data
}
